import React from 'react'
import Alert from "@mui/material/Alert";
import { Link } from 'react-router-dom';

const ErrorComp = () => {
  return (
    <Alert
    severity="warning"
    sx={{
      backgroundColor: "#F052521A", // 10% opacity
      fontWeight: "700",
      color: "#0F0E0E",
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "0px",
      borderRadius: "10px",
      padding: "15px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      "& .MuiAlert-icon": {
        fontSize: "30px",
      },
    }}
  >
    לא הצלחנו לקלוט את נתוני הפנסיה והפיננסים שלך. יתכן והפרטים שגויים.
    <Link
      underline="always"
      to="/profile"
      style={{ color: "#F05252", fontWeight: 700, margin: "0px 5px" }}
    >
      לחץ כאן
    </Link>
     <span style={{marginRight: "5px"}}>
     כדי לעדכן את הפרטים, לעזרה נוספת צור איתנו קשר
     </span> 
  </Alert>
  )
}

export default ErrorComp